import { useQuery } from '@tanstack/react-query';
import PracticeService from '../../../services/practice-service';

const useGetPracticeById = (id: number) => {
  return useQuery({
    queryKey: ['practices', id],
    queryFn: () => PracticeService.getPracticesById(id),
    enabled: !!id,
  });
};

export default useGetPracticeById;
